import React from 'react';
import HeroSection from '../HeroSection';
import '../../App.css';

function Home() {
    return (
        <HeroSection />
    );
}

export default Home;